import { LoginComponent } from './login.component';

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'login',
        component: LoginComponent
      }
    ])
  ],
  exports: [RouterModule]
})
export class LoginRoutingModule { }



// WEBPACK FOOTER //
// /ng-app/src/app/login/login-routing.ts